import { useEffect, useState } from "react";
import FixedAssetDeatils from "./FixedAssetDeatils";
import PurchaseDetails from "./PurchaseDetails";
import SalesDetails from "./SalesDetails";
import {
  FixedAssetAddUpdateType,
  FixedAssetGetFinacAssetType,
  FixedAssetPurchase,
  FixedAssetRegisterForm,
  FixedAssetSingleType,
  GetFARUsersHistoryPayloadType,
} from "../../commonTypes/fixedAssetRegisterTypes";
import { RootState } from "../../redux/rootReducers";
import { connect } from "react-redux";
import {
  addNewFixedAsset,
  getFARUsersHistoryAction,
  getFixedAssetId,
  getSingleFixedAsset,
  updateFixedAsset,
} from "../../redux/fixedAsset/actions";
import {
  resetFinacAssetId,
  resetFixedAssetRegisterError,
  resetFixedAssetRegisterMessage,
  resetFixedAssetRegisterSuccess,
  resetFixedAssetUsersHistoryData,
  resetSingleFixedAsset,
} from "../../redux/fixedAsset";
import { ErrorSuccessModal, Loader } from "../commons";
import { resetSession } from "../../redux/auth";
import { useLocation } from "react-router-dom";
import {
  resetBusinessAddressList,
  resetDepartmentList,
  resetSingleTypeLedgersList,
} from "../../redux/clientSettings";
import MultipleUpload from "../commons/Upload/MultipleUpload";
import { PaperClipIcon } from "../Icon";
import ImageModal from "../../screens/AdminReports/OpenItemsProgressReports/ImageModal";
import { singleImagePreview } from "../../utils/invoiceGeneration/commonFunctions";
import FixedAssetUsersHistory from "./FixedAssetUsersHistory";
import { FixedAssetUsersHistoryData } from "../../redux/fixedAsset/fixedAssetRegisterTypes";

type AppProps = {
  history: any;
  dispatchAddNewFixedAsset: (data: FixedAssetAddUpdateType) => void;
  dispatchGetFixedAssetId: (data: FixedAssetGetFinacAssetType) => void;
  dispatchResetFinacAssetId: () => void;
  token: string | null;
  finacAssetId: string | null;
  fetching: boolean;
  error: string | null;
  success: number | null;
  dispatchResetSession: () => void;
  statusCode: number | null;
  message: string | null;
  dispatchResetFixedAssetRegisterSuccess: () => void;
  dispatchResetFixedAssetRegisterError: () => void;
  dispatchResetFixedAssetRegisterMessage: () => void;
  dispatchGetSingleFixedAsset: (data: FixedAssetSingleType) => void;
  singleFixedAsset: any;
  fixedAssetUsersHistoryData: FixedAssetUsersHistoryData[] | [];
  dispatchUpdateFixedAsset: (data: FixedAssetAddUpdateType) => void;
  dispatchResetSingleFixedAsset: () => void;
  dispatchResetSingleTypeLedgerListAction: () => void;
  dispatchResetDepartmentList: () => void;
  dispatchResetBusinessAddressList: () => void;
  dispatchGetFARUsersHistory: (data: GetFARUsersHistoryPayloadType) => void;
  dispatchResetFixedAssetUsersHistoryData: () => void;
};

const AddEditFixedAssetRegisterForm = ({
  history,
  dispatchGetFixedAssetId,
  dispatchAddNewFixedAsset,
  token,
  finacAssetId,
  dispatchResetFinacAssetId,
  fetching,
  error,
  success,
  dispatchResetSession,
  statusCode,
  message,
  dispatchResetFixedAssetRegisterSuccess,
  dispatchResetFixedAssetRegisterError,
  dispatchGetSingleFixedAsset,
  singleFixedAsset,
  fixedAssetUsersHistoryData,
  dispatchResetFixedAssetRegisterMessage,
  dispatchUpdateFixedAsset,
  dispatchResetSingleFixedAsset,
  dispatchResetSingleTypeLedgerListAction,
  dispatchResetDepartmentList,
  dispatchResetBusinessAddressList,
  dispatchGetFARUsersHistory,
  dispatchResetFixedAssetUsersHistoryData,
}: AppProps) => {
  const { pathname } = useLocation();
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;
  const client_code = history?.location?.state?.client_code;
  const containerName = `clientcontainer${client_code}`;
  const [uploadSuccessArray, setUploadSuccessArray] = useState<any>([]);
  const [uploadData, setUploadData] = useState<any>([]);
  const [imageDetails, setImageDetails] = useState<any>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });
  const [showImagePreview, setShowImagePreview] = useState<boolean>(false);
  const [showPopUpContentModal, setShowPopUpContentModal] =
    useState<boolean>(false);
  const [modal, toggleModal] = useState<boolean>(false);
  const [showFileUploadModal, setShowFileUploadModal] =
    useState<boolean>(false);

  const [storeQRData, setStoreQRData] = useState({
    finac_asset_id: "",
    asset_id: "",
    asset_description: "",
    logo: "",
    sub_location: "",
    department: null,
    category: "",
    gl_code: "",
    departmentLabel: "",
  });
  const [storeQRDataChanges, setStoreQRDataChanges] = useState<string>("");

  const filterData = history?.location?.state?.persistData;
  const company_name =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.company_name
      ? history.location.state.company_name
      : "";
  let finacId =
    history &&
    history.location &&
    history.location.state &&
    history.location.state &&
    history.location.state.id;
  const [fixedAssetRegisterForm, setFixedAssetRegisterForm] =
    useState<FixedAssetRegisterForm>({
      asset_id: "",
      finac_asset_id: "",
      department: null,
      location: null,
      asset_description: "",
      depreciation_method: "Written-down Value",
      date_of_put_to_use: null,
      general_ledger: null,
      condition: "Missing",

      asset_category: "",
      asset_sub_category: "",
      gl_code: "",
      sub_location: "",
      manufacturer: "",
      sales_details: {
        item_name: "",
        customer_name: "",
        invoice_number: "",
        invoice_date: null,
        total_amount: null,
      },
      uploads: [],
      qr_code: "",
      purchase_details: [
        {
          // fixed_asset_id: "",
          item_name: "",
          supplier_name: "",
          invoice_number: "",
          invoice_date: null,
          amount: null,
        },
      ],
    });

  const [selectLoction, setSelectLoction] = useState<any>({
    label: "Select",
    value: null,
    logo: "",
  });

  const [totalPurchaseDetails, setTotalPurchaseDetails] = useState<
    FixedAssetPurchase[]
  >(fixedAssetRegisterForm?.purchase_details);
  const [showFARUsersHistory, setShowFARUsersHistory] =
    useState<boolean>(false);

  useEffect(() => {
    dispatchResetFinacAssetId();
    dispatchResetFixedAssetRegisterSuccess();
    dispatchResetFixedAssetRegisterError();
    dispatchResetFixedAssetRegisterMessage();
    dispatchResetSingleFixedAsset();
    dispatchResetSingleTypeLedgerListAction();
    dispatchResetDepartmentList();
    dispatchResetBusinessAddressList();
    dispatchResetFixedAssetUsersHistoryData();
  }, []);

  useEffect(() => {
    if (showFARUsersHistory && token && singleFixedAsset?.id) {
      dispatchResetFixedAssetUsersHistoryData();
      const finalData = {
        token,
        farId: singleFixedAsset?.id,
      };
      dispatchGetFARUsersHistory(finalData);
    }
  }, [showFARUsersHistory]);

  useEffect(() => {
    if (storeQRData?.asset_id && fixedAssetRegisterForm?.qr_code) {
      if (
        storeQRData?.asset_id !== fixedAssetRegisterForm?.asset_id ||
        storeQRData?.asset_description !==
          fixedAssetRegisterForm?.asset_description ||
        storeQRData?.logo !== selectLoction?.logo ||
        storeQRData?.gl_code != fixedAssetRegisterForm?.gl_code ||
        storeQRData?.category != fixedAssetRegisterForm?.asset_category ||
        storeQRData?.sub_location != fixedAssetRegisterForm?.sub_location ||
        (storeQRData?.department != fixedAssetRegisterForm?.department &&
          fixedAssetRegisterForm?.department)
      ) {
        setStoreQRDataChanges("Some data changed; re-generate QR Code!");
      } else {
        setStoreQRDataChanges("");
      }
    }
  }, [
    storeQRData.finac_asset_id,
    storeQRData.asset_description,
    storeQRData.logo,
    storeQRData.gl_code,
    storeQRData.category,
    storeQRData.sub_location,
    storeQRData.department,
    fixedAssetRegisterForm,
  ]);

  useEffect(() => {
    if (token && client_code && company_name && pathname?.includes("add")) {
      let finalData = {
        token,
        client_code,
        company_name,
      };
      dispatchGetFixedAssetId(finalData);
    }
  }, []);

  useEffect(() => {
    if (uploadData?.length || singleFixedAsset?.uploads?.length) {
      setFixedAssetRegisterForm((prv: any) => {
        return {
          ...prv,
          uploads:
            singleFixedAsset?.upload && uploadData?.length
              ? [...singleFixedAsset?.uploads, ...uploadData]
              : singleFixedAsset?.upload
              ? [...singleFixedAsset?.upload]
              : uploadData?.length
              ? [...uploadData]
              : [],
        };
      });
    }
  }, [singleFixedAsset?.uploads]);

  useEffect(() => {
    if (fixedAssetRegisterForm?.uploads?.length) {
      setUploadData([...fixedAssetRegisterForm?.uploads]);
    }
  }, [fixedAssetRegisterForm?.uploads]);

  useEffect(() => {
    if (Object.keys(singleFixedAsset)?.length && !pathname?.includes("add")) {
      setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
        return {
          id: singleFixedAsset?.id,
          asset_id: singleFixedAsset?.asset_id,
          finac_asset_id: singleFixedAsset?.finac_asset_id,
          department: singleFixedAsset?.department?.value,
          location: singleFixedAsset?.location?.value,
          asset_description: singleFixedAsset?.asset_description,
          depreciation_method: singleFixedAsset?.depreciation_method,
          date_of_put_to_use: singleFixedAsset?.date_of_put_to_use,
          asset_category: singleFixedAsset?.asset_category,
          asset_sub_category: singleFixedAsset?.asset_sub_category,
          gl_code: singleFixedAsset?.gl_code,
          sub_location: singleFixedAsset?.sub_location,
          manufacturer: singleFixedAsset?.manufacturer,
          general_ledger: null,
          condition: singleFixedAsset?.condition,
          sales_details: {
            item_name: singleFixedAsset?.sales_details?.item_name,
            customer_name: singleFixedAsset?.sales_details?.customer_name,
            invoice_number: singleFixedAsset?.sales_details?.invoice_number,
            invoice_date: singleFixedAsset?.sales_details?.invoice_date,
            total_amount: singleFixedAsset?.sales_details?.total_amount,
          },
          uploads: singleFixedAsset?.uploads,
          qr_code: singleFixedAsset?.qr_code,
          purchase_details: singleFixedAsset?.purchase_details,
        };
      });
      setTotalPurchaseDetails(singleFixedAsset?.purchase_details);
    } else {
      setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
        return {
          asset_id: "",
          finac_asset_id: "",
          department: null,
          location: null,
          asset_description: "",
          depreciation_method: "Written-down Value",
          date_of_put_to_use: null,
          general_ledger: null,
          condition: "Missing",

          asset_category: "",
          asset_sub_category: "",
          gl_code: "",
          sub_location: "",
          manufacturer: "",
          sales_details: {
            item_name: "",
            customer_name: "",
            invoice_number: "",
            invoice_date: null,
            total_amount: null,
          },
          uploads: [],
          qr_code: "",
          purchase_details: [
            {
              // fixed_asset_id: "",
              item_name: "",
              supplier_name: "",
              invoice_number: "",
              invoice_date: null,
              amount: null,
            },
          ],
        };
      });
    }
  }, [singleFixedAsset?.purchase_details, singleFixedAsset]);

  useEffect(() => {
    //  finacId;
    dispatchResetFixedAssetRegisterSuccess();
    dispatchResetFixedAssetRegisterError();
    if (finacId) {
      let finalData = {
        token,
        client_code,
        id: finacId,
      };
      dispatchGetSingleFixedAsset(finalData);
    }
  }, []);

  useEffect(() => {
    setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
      return {
        ...prv,
        finac_asset_id: finacAssetId,
      };
    });
  }, [finacAssetId]);

  const handleInputDetailsChange = (e: any) => {
    setFixedAssetRegisterForm((prv: FixedAssetRegisterForm) => {
      return {
        ...prv,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleSubmit = () => {
    Object.keys(fixedAssetRegisterForm).forEach((key) => {
      fixedAssetRegisterForm["uploads"] = uploadData;
    });
    if (
      fixedAssetRegisterForm?.finac_asset_id &&
      fixedAssetRegisterForm?.asset_description &&
      fixedAssetRegisterForm?.asset_id
    ) {
      let finalData = {
        token,
        fixedAssetRegisterForm: { client_code, ...fixedAssetRegisterForm },
      };
      if (pathname?.includes("add")) {
        dispatchAddNewFixedAsset(finalData);
      }
      if (pathname?.includes("edit")) {
        dispatchUpdateFixedAsset(finalData);
      }
    }
  };

  useEffect(() => {
    if (showImagePreview && uploadData?.length) {
      getImageDetails({ ...uploadData[0] }, 0);
    }
  }, [showImagePreview, uploadData]);

  const resetImageUrl = () => {
    setImageDetails({
      imageUrl: "",
      downloadImage: "",
      fileType: "",
      finalFileName: "",
      updateBy: "",
      updatedAt: "",
    });
  };
  const getImageDetails = (data: any, index: any) => {
    setImageDetails({
      ...data,
      imageUrl: blobBaseUrl + data.file_url + "?" + blobToken,
      downloadImage: data.file_url,
      fileType: data.file_type,
      finalFileName: data.file_name,
    });
  };
  const handleUploadFile = (data: any, fileData: any) => {
    setImageDetails(data);
    setShowFileUploadModal(false);
    setUploadData((prevUploadData: any) => [...prevUploadData, data]);
  };

  const showUploadModal = () => {
    toggleModal(!modal);
  };

  const handleEditFileList = (index: number) => {
    const tempFileData = JSON.parse(JSON.stringify(uploadData));
    const updatedFiles = [...uploadData];
    setUploadData(updatedFiles?.filter((e: any) => e?.file_url !== index));
  };

  const renderFilesList = () => {
    const isDelete = false;
    const finalFileList =
      uploadData?.length > 0 &&
      uploadData?.map((data: any, index: number) => {
        return singleImagePreview(
          data,
          index,
          getImageDetails,
          handleEditFileList,
          setShowPopUpContentModal,
          isDelete,
          uploadData
        );
      });
    return finalFileList;
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetFixedAssetRegisterError();
            }}
          />
        );
      }
    }
    if (
      (success === 1 &&
        message === "Fixed asset has been added successfully!") ||
      message === "Fixed asset has been updated successfully!"
    ) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={message}
          buttonText="OK"
          onPress={() => {
            dispatchResetFixedAssetRegisterSuccess();
            dispatchResetFixedAssetRegisterError();
            history?.push({
              pathname: `/fixed-asset-register/fixed-asset-register-list/${client_code}`,
              state: { client_code, company_name, filterData },
            });
          }}
        />
      );
    }
  };

  const handleDeleteAccount = (index: number) => {
    const temp = JSON.parse(JSON.stringify(totalPurchaseDetails));
    temp.splice(index, 1);
    setTotalPurchaseDetails([...temp]);
  };

  return (
    <>
      <FixedAssetDeatils
        fixedAssetRegisterForm={fixedAssetRegisterForm}
        setFixedAssetRegisterForm={setFixedAssetRegisterForm}
        clientCode={client_code}
        handleInputDetailsChange={handleInputDetailsChange}
        singleFixedAsset={singleFixedAsset}
        storeQRData={storeQRData}
        setStoreQRData={setStoreQRData}
        selectLoction={selectLoction}
        setSelectLoction={setSelectLoction}
        storeQRDataChanges={storeQRDataChanges}
        // setDepartmentLabel={setDepartmentLabel}
      />
      <PurchaseDetails
        fixedAssetRegisterForm={fixedAssetRegisterForm}
        setFixedAssetRegisterForm={setFixedAssetRegisterForm}
        handleInputDetailsChange={handleInputDetailsChange}
        totalPurchaseDetails={totalPurchaseDetails}
        setTotalPurchaseDetails={setTotalPurchaseDetails}
        handleDeleteAccount={handleDeleteAccount}
      />
      <SalesDetails
        fixedAssetRegisterForm={fixedAssetRegisterForm}
        setFixedAssetRegisterForm={setFixedAssetRegisterForm}
        handleInputDetailsChange={handleInputDetailsChange}
      />
      <div className="col-md-4 mt-1 mb-3 mt-4 d-flex p-0">
        <div>
          <p
            style={{
              fontSize: "15px",
              fontWeight: "600",
              marginBottom: "11px",
              textAlign: "left",
            }}
          >
            UPLOAD FIXED ASSET FILES
          </p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <button
              className="btn btn-outline"
              onClick={() => {
                showUploadModal();
              }}
            >
              + Upload File
            </button>
            <div className="pointer position-relative ml-4">
              {uploadData?.length ? (
                <span id="Popover1" onClick={() => setShowImagePreview(true)}>
                  <PaperClipIcon />
                  <span className="badge count-badge" style={{ left: "11px" }}>
                    {uploadData?.length}
                  </span>
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
      {pathname?.includes("edit") && (
        <div
          className="col-md-12 mt-5 d-flex justify-content-between form-control"
          style={{
            height: "40px",
            border: "1px solid",
            backgroundColor: "#5c6177",
          }}
        >
          <div>
            <span
              style={{ color: "white" }}
              onClick={() => {
                setShowFARUsersHistory(!showFARUsersHistory);
              }}
            >
              {showFARUsersHistory ? (
                <i className="las la-angle-down pointer"></i>
              ) : (
                <i className="las la-angle-right pointer"></i>
              )}{" "}
              <span
                className="ml-2"
                style={{ color: "white", fontWeight: "500" }}
              >
                Asset Access History
              </span>
            </span>
          </div>
        </div>
      )}
      {showFARUsersHistory ? (
        <FixedAssetUsersHistory data={fixedAssetUsersHistoryData} />
      ) : null}

      <div className="">
        <div className="">
          <div style={{ marginTop: "2rem" }}>
            <hr></hr>
          </div>

          <div className="row mt-3">
            <div className="col-md-12 d-flex justify-content-end ">
              <button
                className="btn ml-3"
                style={{ border: "1px solid #bfcbe1" }}
                onClick={() => {
                  history?.push({
                    pathname: `/fixed-asset-register/fixed-asset-register-list/${client_code}`,
                    state: { client_code, company_name, filterData },
                  });
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary ml-3 pr-4 pl-4"
                onClick={handleSubmit}
                disabled={
                  fixedAssetRegisterForm?.finac_asset_id &&
                  fixedAssetRegisterForm?.asset_description &&
                  fixedAssetRegisterForm?.asset_id &&
                  !storeQRDataChanges?.length &&
                  fixedAssetRegisterForm?.location
                    ? false
                    : true
                }
              >
                {pathname?.includes("add") ? "Save" : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
        {modal ? (
          <MultipleUpload
            modal={modal}
            toggleModal={showUploadModal}
            containerName={containerName}
            handleUploadFile={handleUploadFile}
            isDraggableModal
            acceptedFiles="image/png, image/gif, application/pdf , image/jpeg, .csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"
            supportedFiles="PNG, JPEG, PDF, Excel, PPT, PPTX and Doc."
            uploadSuccessArray={uploadSuccessArray}
            setUploadSuccessArray={setUploadSuccessArray}
          />
        ) : null}
        {showImagePreview && (
          <ImageModal
            showImagePreview={showImagePreview}
            setShowImagePreview={setShowImagePreview}
            resetImageUrl={resetImageUrl}
            imageDetails={imageDetails}
            renderFilesList={renderFilesList}
            uploadData={uploadData}
            setUploadData={setUploadData}
            type={"jobDetails"}
            handleEditFileList={handleEditFileList}
            isDelete={true}
          />
        )}
      </div>
      {fetching && <Loader />}
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.fixedAssetRegister.fetching,
  finacAssetId: state.fixedAssetRegister.finacAssetId,
  success: state.fixedAssetRegister.success,
  message: state.fixedAssetRegister.message,
  statusCode: state.fixedAssetRegister.statusCode,
  error: state.fixedAssetRegister.error,
  singleFixedAsset: state.fixedAssetRegister.singleFixedAsset,
  fixedAssetUsersHistoryData:
    state.fixedAssetRegister.fixedAssetUsersHistoryData,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchAddNewFixedAsset: (data: FixedAssetAddUpdateType) =>
    dispatch(addNewFixedAsset(data)),
  dispatchGetFixedAssetId: (data: FixedAssetGetFinacAssetType) =>
    dispatch(getFixedAssetId(data)),
  dispatchResetFinacAssetId: () => dispatch(resetFinacAssetId()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetFixedAssetRegisterSuccess: () =>
    dispatch(resetFixedAssetRegisterSuccess()),
  dispatchResetFixedAssetRegisterError: () =>
    dispatch(resetFixedAssetRegisterError()),
  dispatchResetFixedAssetRegisterMessage: () =>
    dispatch(resetFixedAssetRegisterMessage()),
  dispatchResetSingleTypeLedgerListAction: () =>
    dispatch(resetSingleTypeLedgersList()),
  dispatchGetSingleFixedAsset: (data: FixedAssetSingleType) =>
    dispatch(getSingleFixedAsset(data)),
  dispatchUpdateFixedAsset: (data: FixedAssetAddUpdateType) =>
    dispatch(updateFixedAsset(data)),
  dispatchGetFARUsersHistory: (data: GetFARUsersHistoryPayloadType) =>
    dispatch(getFARUsersHistoryAction(data)),
  dispatchResetFixedAssetUsersHistoryData: () =>
    dispatch(resetFixedAssetUsersHistoryData()),
  dispatchResetSingleFixedAsset: () => dispatch(resetSingleFixedAsset()),
  dispatchResetDepartmentList: () => dispatch(resetDepartmentList()),
  dispatchResetBusinessAddressList: () => dispatch(resetBusinessAddressList()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEditFixedAssetRegisterForm);
